// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* breakpoints */
/* Using .9375 on the max-widths prevents overlap at the breakpoint pixel. 1em by default equals 16px, .9375 is 15/16ths */`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/styles/variables.module.css"],"names":[],"mappings":"AAMA,gBAAgB;AAChB,0HAA0H","sourcesContent":["@value spacingXS: 11px;\n@value spacingSM: 22px;\n@value spacingMD: 33px;\n@value spacingLG: 44px;\n@value spacingXL: 55px;\n\n/* breakpoints */\n/* Using .9375 on the max-widths prevents overlap at the breakpoint pixel. 1em by default equals 16px, .9375 is 15/16ths */\n@value endXS:     47.9375em;\n@value startSM:   48em;\n@value endSM:     61.9375em;\n@value startMD:   62em;\n@value endMD:     74.9375em;\n@value startLG:   75em;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spacingXS": `11px`,
	"spacingSM": `22px`,
	"spacingMD": `33px`,
	"spacingLG": `44px`,
	"spacingXL": `55px`,
	"endXS": `47.9375em`,
	"startSM": `48em`,
	"endSM": `61.9375em`,
	"startMD": `62em`,
	"endMD": `74.9375em`,
	"startLG": `75em`
};
export default ___CSS_LOADER_EXPORT___;
